import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiCustomerSlideout extends Layout {
    sourceEdiCustomer: DataSource;
    textboxCarrier: Textbox;
    textboxCustomerId: Textbox;
    textboxScac: Textbox;
}
